// Holiday / closure windows (name + start + end in the location's local time).

import { Plus, Trash2 } from 'lucide-react';
import type { HolidayRange } from '../../api/client';
import { inputCls, smallBtnCls } from './common';

export function HolidaysEditor({ value, onChange, max = 40 }: {
  value: HolidayRange[];
  onChange: (v: HolidayRange[]) => void;
  max?: number;
}) {
  const update = (i: number, patch: Partial<HolidayRange>) => onChange(value.map((h, j) => (j === i ? { ...h, ...patch } : h)));
  return (
    <div>
      {value.map((h, i) => (
        <div key={i} className="flex flex-wrap gap-2 mb-1.5 items-center">
          <input type="text" value={h.name} placeholder="Christmas" className={`${inputCls} flex-1 min-w-[8rem]`}
            onChange={e => update(i, { name: e.target.value })} />
          <input type="datetime-local" value={h.start.length === 10 ? `${h.start}T00:00` : h.start} className={`${inputCls} w-auto`}
            onChange={e => update(i, { start: e.target.value })} />
          <span className="text-gray-400 text-xs">–</span>
          <input type="datetime-local" value={h.end.length === 10 ? `${h.end}T23:59` : h.end} className={`${inputCls} w-auto`}
            onChange={e => update(i, { end: e.target.value })} />
          <button type="button" onClick={() => onChange(value.filter((_, j) => j !== i))} className="p-1.5 text-gray-400 hover:text-red-600"><Trash2 className="w-4 h-4" /></button>
        </div>
      ))}
      {value.length < max && (
        <button type="button" onClick={() => {
          const d = new Date(); const day = d.toISOString().slice(0, 10);
          onChange([...value, { name: '', start: `${day}T00:00`, end: `${day}T23:59` }]);
        }} className={smallBtnCls}><Plus className="w-3 h-3" />Add holiday</button>
      )}
    </div>
  );
}
